module.exports = __webpack_public_path__ + "static/media/grid_pig02.06efc010.svg";